import {combine, merge, sample} from 'effector';

import {RestError, showRestError} from 'core/errors';
import {mapFilters} from 'utils/filters';

import {
    pageNumber$,
    pageNumberChanged,
    fetchDataFx,
    filtersChanged,
    data$,
    filters$,
    sorting$,
    sortingChanged,
    Gate,
    pageIncremented,
    pageSize$,
    // totalCount$,
    fetchTotalCountFx,
} from './index';

data$
    .on(fetchDataFx.done, (state, {result}) => state.concat(result))
    .reset(sortingChanged, filtersChanged, Gate.close);
pageNumber$.reset(filtersChanged, sortingChanged, Gate.close);
pageSize$.reset(Gate.close);
sorting$.reset(Gate.close);
filters$.reset(Gate.close);

sample({
    clock: pageIncremented,
    source: pageNumber$.map((state) => state + 1),
    target: pageNumberChanged,
});

sample({
    clock: merge([Gate.open, pageNumberChanged]),
    source: combine({
        state: Gate.state,
        pageNumber: pageNumber$,
        pageSize: pageSize$,
        filters: filters$,
        sorting: sorting$,
    }),
    fn: ({state, pageNumber, pageSize, filters, sorting}) => ({
        reportId: state.reportId,
        paging: {
            pageNumber,
            pageSize,
        },
        filters: mapFilters(filters),
        sortings: sorting,
    }),
    target: fetchDataFx,
});

fetchDataFx.fail.watch(({error}) => showRestError(error as RestError));
fetchTotalCountFx.fail.watch(({error}) => showRestError(error as RestError));
